import type { PropsWithChildren } from 'react';

import ProfileContext, { type ProfileContextProps } from './ProfileContext';

const ProfileContextProvider = ({
  children,
  profile,
  actingProfile,
}: PropsWithChildren<ProfileContextProps>) => {
  return (
    <ProfileContext.Provider
      value={{
        profile,
        actingProfile,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export default ProfileContextProvider;
